<template>
  <div
    ref="imageContainer"
    v-editable="blok"
    :class="leaderClasses"
    :style="blok.background_image | optimizeImage(width,height) | makeBackground"
  >
    <a :id="blok.anchor"></a>
    <div :class="containerClasses">
      <component
        :key="index"
        v-for="(child,index) in blok.content"
        :blok="child"
        :is="child.component"
      ></component>
    </div>
  </div>
</template>
<script>
export default {
  name: "leader",
  props: ["blok"],
  data: () => {
    return {
      width: 0,
      height: 0
    }
  },
  computed: {
    leaderClasses: function() {
      return [
        "leader", 
        this.blok.fixed_background ? "fixed-bg" : "",
        this.blok.fit_image ? "contain" : "",
        this.blok.height_style,
        this.blok.height_style_mobile,
        this.blok.custom_styles
      ];
    },
    containerClasses: function() {
        return this.blok.fluid_container ? "container-fluid" : "blok-container";
    }
  },
  filters: {
    makeBackground: function(v) {
      return `background-image: url(${v})`;
    }
  },
  mounted: function() {
    const rect = this.$refs.imageContainer.getBoundingClientRect();
    this.width = rect.width;
    this.height = rect.height;
  }
};
</script>
